import './globals';
import './methods';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './components/error-boundary';
import moment from 'moment';
import idLocale from 'moment/locale/id';

moment.locale('id');
moment.updateLocale('id', [idLocale]);

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('app')
);
